import { useCallback } from 'react';

const isValidLocale = (locale) => {
  return /^[a-z]{2}(-[A-Z]{2})?$/i.test(locale);
};

export const useTranslationService = (translations, prefix = 'org_listing') => {
  const t = useCallback((key, variables = {}) => {
    const vars = Object.keys(variables);
    
    const possibleKey = key.startsWith(prefix) ? key : `${prefix}__${key}`;

    let text = translations[possibleKey] || possibleKey.toString().toLocaleUpperCase();

    if(vars.length) {
        vars.forEach((variableName) => {
            text = text.replace('%' + variableName + '%', variables[variableName]);
        })
    }

    return text;
  }, [translations, prefix]);

  return {
    t,
    isValidLocale,
  }
}

// Translation fetching service functions
export function translationService(apiUrl) {
  const getTranslationVersion = async (locale, namespace) => {
    try {
      const response = await fetch(`${apiUrl}/translations/v2/version/${locale}/${namespace}`);
      if (!response.ok) {
        throw new Error(await response.text());
      }
      return await response.json();
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  const getTranslations = async (locale, namespace, version, fallbackLocale = 'en_US') => {
    try {
      const response = await fetch(`${apiUrl}/translations/v2/${locale}/${namespace}/${version}/${fallbackLocale}`);
      if (!response.ok) {
        throw new Error(await response.text());
      }
      return await response.json();
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  return {
    getTranslationVersion,
    getTranslations
  }
}
